import { AuthorizationController } from './authorization.controller';
import template from './authorization.html';

export const authorizationComponent = {
  name: 'authorizationComponent',
  restrict: 'E',
  template,
  controller: AuthorizationController,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<'
  }
};
